var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    { ref: "form", staticClass: "max-width pa-0" },
    [
      _c("ContinuousSurfaceWaterChart", {
        attrs: { id: "stationGraphChart", requestData: _vm.requestData },
      }),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-actions",
            { staticClass: "card-bg-2 py-0 layout wrap", attrs: { wrap: "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "my-2 ml-0 mr-2",
                  attrs: { color: "info" },
                  on: {
                    click: function ($event) {
                      return _vm.generateGraph()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [
                    _vm._v("insert_chart"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm.$t("Button.Generate_Graph"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "my-2 ml-0",
                  attrs: { loading: _vm.loadingDownload },
                  on: {
                    click: function ($event) {
                      return _vm.download()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-1" }, [_vm._v("save_alt")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-capitalize" }, [
                    _vm._v(_vm._s(_vm.$t("Button.DownloadReport"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-progress-linear", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loadingSpinner,
                expression: "loadingSpinner",
              },
            ],
            staticClass: "ma-0",
            attrs: { indeterminate: "", color: "blue" },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "background-color": "white" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "ma-0",
                  attrs: {
                    outline: "",
                    transition: "slide-y-transition",
                    type: "info",
                    value:
                      _vm.showErrorBox &&
                      (_vm.alertShow ||
                        _vm.noSelectionWarning ||
                        _vm.invalidDatesWarning),
                  },
                },
                [
                  _vm.noSelectionWarning
                    ? _c("div", { staticClass: "primary--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("StationDetailDownload.alertDateSeries")
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.invalidDatesWarning
                    ? _c("div", { staticClass: "primary--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("StationDetailDownload.alertDateRange")
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.alertShow
                    ? _c("div", { staticClass: "primary--text" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "StationDetailDownload.alertStatisticalValue"
                              )
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "card-bg-2", attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "divider-right", attrs: { xs12: "", md5: "" } },
                [
                  _c("v-card-title", { staticClass: "headline pb-0" }, [
                    _vm._v("Date Range"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pb-0" },
                    [
                      _c("DateRange", {
                        attrs: {
                          rounded: "",
                          solo: "",
                          minDate: _vm.minDate,
                          maxDate: _vm.maxDate,
                          availableDateRange: {
                            start: _vm.minDate,
                            end: _vm.maxDate,
                          },
                          "min-max-placeholder": _vm.formats.prettyDateFormat,
                          shortcutPrefix: "Show",
                          shortcuts: _vm.shortcuts,
                          "no-arrows": "",
                          data: _vm.availableDates,
                        },
                        on: {
                          "update:selectedRange": function ($event) {
                            _vm.selectedRange = $event
                          },
                        },
                        model: {
                          value: _vm.dates,
                          callback: function ($$v) {
                            _vm.dates = $$v
                          },
                          expression: "dates",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-title",
                    { staticClass: "headline pb-0" },
                    [
                      _vm._v("\n          Include gap markers\n          "),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "offset-y": "",
                            "open-on-hover": "",
                            "open-delay": 400,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "v-icon",
                                    _vm._g(
                                      {
                                        staticClass: "clickable ml-2",
                                        attrs: { color: "primary" },
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        "\n              info_outline\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-card",
                            [
                              _c("v-card-text", [
                                _vm._v(
                                  '\n              "Include gap markers" inserts a row mid-way between the start and end of a gap, and applies a missing (M) grade for that row.\n            '
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "pb-0" },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "" },
                          model: {
                            value: _vm.includeGapMarkers,
                            callback: function ($$v) {
                              _vm.includeGapMarkers = $$v
                            },
                            expression: "includeGapMarkers",
                          },
                        },
                        [
                          _c("v-radio", {
                            attrs: {
                              color: "info",
                              "hide-details": "",
                              label: "No",
                              value: false,
                            },
                          }),
                          _vm._v(" "),
                          _c("v-radio", {
                            attrs: {
                              color: "info",
                              "hide-details": "",
                              label: "Yes",
                              value: true,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v("\n          Download Options\n\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _c(
                        "v-radio-group",
                        {
                          attrs: { row: "" },
                          model: {
                            value: _vm.downloadOption,
                            callback: function ($$v) {
                              _vm.downloadOption = $$v
                            },
                            expression: "downloadOption",
                          },
                        },
                        _vm._l(
                          _vm.downloadTypes,
                          function (downloadType, index) {
                            return _c("v-radio", {
                              key: `downloadType-${index}`,
                              attrs: {
                                color: "info",
                                "hide-details": "",
                                label: downloadType.name,
                                value: downloadType,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.downloadOption == _vm.downloadTypes.statistic
                    ? [
                        _c(
                          "div",
                          { staticClass: "mb-2" },
                          [
                            _c(
                              "SecondaryBtn",
                              { on: { click: _vm.toggleAdvancedOptions } },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", left: "" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.dailyStatisticsAdvancedOptionIcon
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(
                                  "\n              Advanced Options\n            "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-expand-transition",
                          [
                            _c(
                              "v-card-text",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showAdvancedOptions,
                                    expression: "showAdvancedOptions",
                                  },
                                ],
                                staticClass: "card-bg-1 mb-2",
                                attrs: { transition: "slide-y-transition" },
                              },
                              [
                                _c("DailyStatisticTimeOffset", {
                                  attrs: {
                                    startDate: _vm.dates.start,
                                    endDate: _vm.dates.end,
                                  },
                                  model: {
                                    value: _vm.hourOffset,
                                    callback: function ($$v) {
                                      _vm.hourOffset = $$v
                                    },
                                    expression: "hourOffset",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-data-table", {
                          staticClass: "elevation-1",
                          attrs: {
                            pagination: { rowsPerPage: -1 },
                            headers: _vm.dialogHeaders,
                            items: _vm.shownStatistics,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "no-data",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "pa-4 text-xs-center" },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "warning" } },
                                          [_vm._v("warning")]
                                        ),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(
                                          "\n                Select a time series\n              "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "headers",
                                fn: function () {
                                  return [
                                    _c("tr", [
                                      _c(
                                        "th",
                                        {
                                          staticClass:
                                            "text-xs-left time-series-column",
                                          staticStyle: {
                                            "padding-bottom": "24px",
                                          },
                                        },
                                        [_vm._v("Data Series Name")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "th",
                                        { staticClass: "py-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "text-xs-left" },
                                            [_vm._v("Daily Statistics")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-layout",
                                            _vm._l(
                                              _vm.statisticTypes,
                                              function (statisticType, index) {
                                                return _c("v-checkbox", {
                                                  key: `statisticTotals-${index}`,
                                                  staticClass: "mr-1",
                                                  style: {
                                                    order: statisticType.order,
                                                  },
                                                  attrs: {
                                                    color: "primary",
                                                    label: statisticType.name,
                                                    indeterminate:
                                                      _vm.selectedStatistics[
                                                        statisticType.key
                                                      ].hasSome &&
                                                      !_vm.selectedStatistics[
                                                        statisticType.key
                                                      ].hasAll,
                                                    "input-value":
                                                      _vm.selectedStatistics[
                                                        statisticType.key
                                                      ].hasAll,
                                                    disabled:
                                                      _vm.shownStatistics
                                                        .length == 0 ||
                                                      (statisticType ==
                                                        _vm.statisticTypes
                                                          .total &&
                                                        !_vm.shownStatistics.some(
                                                          (item) => item.Total
                                                        )),
                                                    "hide-details": "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      $event.preventDefault()
                                                      return _vm.toggleStatisticType(
                                                        statisticType
                                                      )
                                                    },
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "items",
                                fn: function ({ item, index }) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "time-series-column" },
                                      [_vm._v(_vm._s(item.DisplayName))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-layout",
                                          _vm._l(
                                            _vm.statisticTypes,
                                            function (
                                              statisticType,
                                              statIndex
                                            ) {
                                              return _c("v-checkbox", {
                                                key: `${index}-statisticType-${statIndex}`,
                                                staticClass: "mr-1",
                                                style: {
                                                  order: statisticType.order,
                                                },
                                                attrs: {
                                                  color: "info",
                                                  value: statisticType.value,
                                                  rules: [_vm.rules.hasOne],
                                                  disabled:
                                                    statisticType ==
                                                      _vm.statisticTypes
                                                        .total && !item.Total,
                                                  "hide-details": "",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "label",
                                                      fn: function () {
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "visibility-hidden",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                        " +
                                                                  _vm._s(
                                                                    statisticType.name
                                                                  ) +
                                                                  "\n                      "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                      proxy: true,
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                                model: {
                                                  value: item.Statistics,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "Statistics",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.Statistics",
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1796084135
                          ),
                        }),
                        _vm._v(" "),
                        _c(
                          "v-alert",
                          {
                            staticClass: "ma-0 py-2",
                            staticStyle: { background: "white" },
                            attrs: {
                              outline: "",
                              transition: "slide-y-transition",
                              type: "warning",
                              value: _vm.shownStatistics.some(
                                (item) => !item.Total
                              ),
                            },
                          },
                          [
                            _c("div", { staticClass: "primary--text" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "StationDetailDownload.alertDailyTotal"
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-title",
                          { staticClass: "headline pb-0" },
                          [
                            _vm._v("\n          Fill Gaps\n          "),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "offset-y": "",
                                  "open-on-hover": "",
                                  "open-delay": 400,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "clickable ml-2",
                                                attrs: { color: "primary" },
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n              info_outline\n            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1233606610
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-card",
                                  [
                                    _c("v-card-text", [
                                      _vm._v(
                                        '\n              "Fill Gaps" inserts a row of date without data, and applies a missing (M) grade for that row.\n            '
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-card-text",
                          { staticClass: "pb-0" },
                          [
                            _c(
                              "v-radio-group",
                              {
                                attrs: { row: "" },
                                model: {
                                  value: _vm.fillGaps,
                                  callback: function ($$v) {
                                    _vm.fillGaps = $$v
                                  },
                                  expression: "fillGaps",
                                },
                              },
                              [
                                _c("v-radio", {
                                  attrs: {
                                    color: "info",
                                    "hide-details": "",
                                    label: "No",
                                    value: false,
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-radio", {
                                  attrs: {
                                    color: "info",
                                    "hide-details": "",
                                    label: "Yes",
                                    value: true,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-divider"),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { staticClass: "divider-left", attrs: { xs12: "", md7: "" } },
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "headline pb-0",
                          staticStyle: {
                            "align-items": "baseline",
                            display: "flex",
                          },
                        },
                        [_vm._v("\n            Time series\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        staticClass: "rounded font-weight-regular",
                        attrs: {
                          "prepend-inner-icon": "search",
                          "hide-details": "",
                          clearable: "",
                          solo: "",
                          placeholder: "Search time series",
                        },
                        on: {
                          "click:clear": function ($event) {
                            return _vm.clearSearch()
                          },
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.toggleCurrentItems($event)
                          },
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-item-group",
                    {
                      attrs: { mandatory: "", "active-class": "white--text" },
                      model: {
                        value: _vm.filterToggle,
                        callback: function ($$v) {
                          _vm.filterToggle = $$v
                        },
                        expression: "filterToggle",
                      },
                    },
                    [
                      _c(
                        "v-subheader",
                        {
                          staticStyle: { display: "inline", cursor: "default" },
                        },
                        [_vm._v("Show:")]
                      ),
                      _vm._v(" "),
                      _c("v-item", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ active, toggle }) {
                              return _c(
                                "v-chip",
                                {
                                  staticClass: "chipFilter",
                                  attrs: {
                                    small: "",
                                    color: active ? "primary" : "default",
                                    selected: active,
                                  },
                                  on: { click: toggle },
                                },
                                [_vm._v("All")]
                              )
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("v-item", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ active, toggle }) {
                              return _c(
                                "v-chip",
                                {
                                  staticClass: "chipFilter",
                                  attrs: {
                                    small: "",
                                    color: active ? "primary" : "default",
                                    selected: active,
                                  },
                                  on: { click: toggle },
                                },
                                [
                                  _c(
                                    "v-avatar",
                                    {
                                      staticClass: "chip-log-count",
                                      staticStyle: { "border-radius": "0px" },
                                    },
                                    [_vm._v(_vm._s(_vm.selected.length))]
                                  ),
                                  _vm._v(
                                    "\n              Selected\n            "
                                  ),
                                ],
                                1
                              )
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "timeSeriesTable",
                    staticClass: "table-default-bg",
                    class: {
                      "five-items": _vm.pagination.rowsPerPage === 5,
                      "ten-items": _vm.pagination.rowsPerPage === 10,
                      "twenty-five-items": _vm.pagination.rowsPerPage === 25,
                    },
                    attrs: {
                      items: _vm.datasets,
                      headers: _vm.headers,
                      search: _vm.search,
                      "select-all": "",
                      pagination: _vm.pagination,
                      "item-key": _vm.ID_KEY,
                      "custom-filter": _vm.customFilter,
                    },
                    on: {
                      "update:pagination": function ($event) {
                        _vm.pagination = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "headers",
                        fn: function (props) {
                          return [
                            _c(
                              "tr",
                              [
                                _c(
                                  "th",
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        color: "primary",
                                        "input-value": props.all,
                                        indeterminate: props.indeterminate,
                                        primary: "",
                                        "hide-details": "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.toggleAll()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(props.headers, function (header) {
                                  return _c(
                                    "th",
                                    {
                                      key: header.text,
                                      class: [
                                        "column sortable",
                                        _vm.pagination.descending
                                          ? "desc"
                                          : "asc",
                                        header.value === _vm.pagination.sortBy
                                          ? "active"
                                          : "",
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeSort(header.value)
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("arrow_upward"),
                                      ]),
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(header.text) +
                                          "\n              "
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                      {
                        key: "items",
                        fn: function (props) {
                          return [
                            _c(
                              "tr",
                              {
                                staticClass: "clickable",
                                attrs: { active: props.selected },
                                on: {
                                  click: function ($event) {
                                    props.selected = !props.selected
                                  },
                                },
                              },
                              [
                                _c(
                                  "td",
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        color: "info",
                                        primary: "",
                                        "hide-details": "",
                                        "input-value": props.selected,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(props.item.DisplayName)),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatDate(
                                          props.item.FirstRecordDate,
                                          _vm.formats.prettyDateTimeFormatShort
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-xs-left" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formatDate(
                                          props.item.LastRecordDate,
                                          _vm.formats.prettyDateTimeFormatShort
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-xs-left" },
                                  _vm._l(props.item.Tags, function (tag) {
                                    return _c(
                                      "v-chip",
                                      {
                                        key: tag,
                                        attrs: {
                                          small: "",
                                          disabled: "",
                                          "text-color": "black",
                                        },
                                      },
                                      [_vm._v(_vm._s(tag))]
                                    )
                                  }),
                                  1
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.selected,
                      callback: function ($$v) {
                        _vm.selected = $$v
                      },
                      expression: "selected",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "640" },
          model: {
            value: _vm.confirming,
            callback: function ($$v) {
              _vm.confirming = $$v
            },
            expression: "confirming",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("h5", [
                  _vm._v(
                    'There is a problem with the name of the time series "' +
                      _vm._s(_vm.invalidTimeSeries.join()) +
                      "\" you are trying to calculate daily statistics on. Daily statistics will be calculated but partial grades ('A') may not be properly assigned. Please contact 'envirodata-techsupport@hatfieldgroup.com' to have this issue addressed."
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.continueDownload },
                    },
                    [_vm._v("Download anyway")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      on: { click: _vm.cancelDownload },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.No")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }